import styled from '@emotion/styled'

import SearchInput from 'components/patterns/Inputs/SearchInput'
import { HoverableInfoIcon } from 'components/patterns'

export const SearchWrapper = styled.div`
  display: flex;
  flex-direction: row;
`

export const SearchInputField = styled(SearchInput)`
  width: 500px;
`
export const SearchInfoIcon = styled(HoverableInfoIcon)`
  display: block;
`
